import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import _, { forEach as _forEach } from 'lodash';
import { removeUsers, reverseRemovedUsers } from 'actions/ListActions';

class UsersRemove extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFiles: [],
      selectedUrls: [],
      progressInfo: [],
      progressInfoRun: [],
      uploading: false,
      showRemoveButton: false,
      showReverseButton: false,
      actionType: '',
      showErrors: false,
      fileEmails: [],
    };
  }

  componentDidMount = () => {};

  extractEmailsFromCSV = (csvData) => _.uniq(csvData.split('\n').map((email) => email.trim().replace(",", "").replace("\\r", "")));

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.progressInfo.length > 0 && this.state.uploading === false && (this.state.actionType === 'remove' || this.state.actionType === 'reverse')) {
      this.setState({ uploading: true });
      this.upload();
    }

    if (prevProps.pendingUI !== this.props.pendingUI && this.props.pendingUI === false) {
      this.setState({ progressInfo: [], uploading: false, showRemoveButton: false, showErrors: true });
    }
    if (
      prevProps.pendingUI !== this.props.pendingUI &&
      this.props.pendingUI === false &&
      this.state.selectedFiles?.length > 0
    ) {
      this.setState({ showReverseButton: true });
    }
    if (prevState.selectedFiles !== this.state.selectedFiles) {
      this.setState({ showReverseButton: false });
    }

    if (prevProps.pendingRI !== this.props.pendingRI && this.props.pendingRI === false) {
      this.setState({ progressInfo: [], uploading: false, showReverseButton: false });
    }
  };

  selectFile = event => {
    this.setState({ selectedFiles: event.target.files, progressInfo: [], progressInfoRun: [], showRemoveButton: true });

    let _selectedUrls = [];
    _forEach(event.target.files, (files, i) => {
      _selectedUrls.push(URL.createObjectURL(files));
    });
    if (_selectedUrls.length === event.target.files.length) {
      this.setState({ selectedUrls: _selectedUrls });
    }
    const reader = new FileReader();
    let that = this;
    reader.onload = function(event) {
      const csvData = event.target.result;
      console.log(csvData.replace("Email", "").trim());
      that.setState({ fileEmails: that.extractEmailsFromCSV(csvData.replace("Email", "").trim()) });
    };
    reader.readAsText(event.target.files[0]);
  };

  upload = () => {
    let _progressInfosNeu = [...this.state.progressInfo];
    let _selectedFiles = this.state.selectedFiles.length;
    for (let idx = 0; idx < this.state.selectedFiles.length; idx++) {
      let file = this.state.selectedFiles[idx];
      let formData = new FormData();
      formData.append('files', file);
      var values = formData.values();
      const uploadProgress = {
        onUploadProgress: ProgressEvent => {
          _progressInfosNeu[idx].percentage = Math.round((100 * ProgressEvent.loaded) / ProgressEvent.total);
          this.setState({ progressInfoRun: this.state.progressInfoRun.concat(_progressInfosNeu) });
        },
      };
      if (this.state.actionType === "remove") {
        this.props.removeUsers(formData, uploadProgress, _selectedFiles - 1);
        this.setState({ actionType: "" });
      }
      if (this.state.actionType === "reverse") {
        this.props.reverseUsers(formData, uploadProgress, _selectedFiles - 1);
        this.setState({ actionType: "" });
      }

      _selectedFiles--;
    }
  };

  uploadSplit = () => {
    /* could upload multiple if needed */
    let _progressInfos = [];
    for (let i = 0; i < this.state.selectedFiles.length; i++) {
      _progressInfos.push({ percentage: 0 });
    }
    this.setState({ progressInfo: this.state.progressInfo.concat(_progressInfos), actionType: "remove" });
  };

  reverseRemove = () => {
    let _progressInfos = [];
    for (let i = 0; i < this.state.selectedFiles.length; i++) {
      _progressInfos.push({ percentage: 0 });
    }
    this.setState({ progressInfo: this.state.progressInfo.concat(_progressInfos), actionType: "reverse" });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      user,
      location,
    } = this.props;

    const errorsOutput = [];

    _forEach(this.props.errorMessages, (errorM, i) => {
      errorM?.duplicate &&
        errorsOutput.push(
          <p style={{ color: '#CF1719' }}>{messages.user_duplicate_remove + ': ' + errorM.duplicate}</p>
        );
      errorM?.db_update_errors &&
        errorM.email &&
        errorsOutput.push(
          <p style={{ color: '#CF1719' }}>UpdateError: {errorM.db_update_errors + ' - Email: ' + errorM.email} </p>
        );
      errorM?.db_errors && errorsOutput.push(<p style={{ color: '#CF1719' }}>Error: {errorM.db_errors}</p>);
      errorM?.success_user &&
        errorsOutput.push(
          <p style={{ color: '#008B00' }}>{messages.user_remove_success + ': ' + errorM.success_user}</p>
        );
    });

    const numDigits = this.state.fileEmails.length.toString().length;
    const zeroPad = (num, places) => String(num).padStart(places, '0')
    let startingNumber = 0;
    return (
      <>
        <div className="padding-25 sm-padding-10" style={{ backgroundColor: '#FFFFFF' }}>
          <Breadcrumb
            crumbs={[
              { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
              { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
              { link: null, name: messages.remove_users },
            ]}
            className="p-t-0"
          />
          <h1>{messages.remove_users}</h1>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h3>{messages.choice_csv}</h3>
          {this.props.pendingUI ? (
            <Loader />
          ) : (
            <>
              <div className="image-upload">
                <label
                  htmlFor="file-input"
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    marginTop: '20px',
                    width: '100px',
                    height: '100px',
                    cursor: 'pointer',
                  }}
                >
                  <span>
                    <i
                      className="far fa-plus-circle"
                      style={{ color: '#FFFFFF', fontSize: '100px', cursor: 'pointer' }}
                    />
                  </span>
                </label>
                <input
                  id="file-input"
                  type="file"
                  accept=".csv"
                  onChange={e => {
                    this.selectFile(e);
                  }}
                />
              </div>
              <div>
                {this.state.selectedFiles && this.state.selectedFiles.length > 0 && this.state.showRemoveButton ? (
                  <button
                    style={{ display: 'block', margin: '0 auto', marginTop: '20px' }}
                    onClick={this.uploadSplit}
                    className="btn btn-success card-button"
                  >
                    <i className="far fa-upload"></i>
                    <span> {messages.start_remove}</span>
                  </button>
                ) : (
                  <></>
                )}
              </div>
              <div>
                {this.state.showReverseButton ? (
                  <button
                    style={{ display: 'block', margin: '0 auto', marginTop: '20px' }}
                    onClick={this.reverseRemove}
                    className="btn btn-warning card-button"
                  >
                    <i className="far fa-history"></i>
                    <span> {messages.reverse_remove}</span>
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </>
          )}
          <div>
            <p style={{ margin: '10px' }}>
              <span>
                {this.props.message && this.props.message === 'pending' && messages.remove_exec}
                {this.props.message && this.props.message === 'fulfilled' && messages.remove_success}
                {this.props.message && this.props.message === 'rejected' && messages.remove_rejected}
                {this.props.message && this.props.message === 'pendingRE' && messages.remove_execRE}
                {this.props.message && this.props.message === 'fulfilledRE' && messages.remove_successRE}
                {this.props.message && this.props.message === 'rejectedRE' && messages.remove_rejectedRE}
              </span>
            </p>
          </div>
          {this.state.showErrors ? (
            <div>
              <h3>{messages.warning_and_notes}</h3>
              {errorsOutput.length > 0 ? errorsOutput : <span>keine</span>}
            </div>
          ) : (
            <></>
          )}
          {this.state.fileEmails.length > 0 ? (
            <div className="container">
              <h3>{messages.csv_content}</h3>
              <div style={{width: "fit-content", alignContent: "left", margin: "10px auto"}}>
                {this.state.fileEmails.map(email => {
                  startingNumber++;
                  return (
                    <div key={email} style={{ width: "100%", textAlign: "left", marginBottom: "15px", borderBottom: "1px solid #cd1718", paddingLeft: "10px"}}>
                      <i>{zeroPad(startingNumber, numDigits)}</i><b style={{ marginLeft: "10px"}}>{email}</b>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.users,
    user: state.login.user,
    pendingUI: state.list.userRemove.pendingUI,
    message: state.list.userRemove.messageUI,
    pendingRI: state.list.userRemove.pendingRI,
    errorMessages: state.list.userRemove.errorMessages,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    removeUsers: (formData, uploadProgress, _selectedFiles) => {
      dispatch(removeUsers(formData, uploadProgress, _selectedFiles));
    },
    reverseUsers: (formData, uploadProgress, _selectedFiles) => {
      dispatch(reverseRemovedUsers(formData, uploadProgress, _selectedFiles));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(UsersRemove)
  )
);
